import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'

import { AuthProvider } from './hooks/useAuth'
import { LandingPage } from './components/landing/LandingPage'
import { ImageTest } from './components/landing/ImageTest'
import { LoginForm } from './components/auth/LoginForm'
import { RegisterForm } from './components/auth/RegisterForm'
import { ActivationPage } from './components/auth/ActivationPage'
import { ForgotPasswordPage, ResetPasswordPage } from './components/auth/ResetPasswordPage'
import { MainLayout } from './components/dashboard/MainLayout'
import { ProjectsPage } from './pages/ProjectsPage'
import { UserProfile } from './components/dashboard/UserProfile'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { LegalNoticePage } from './pages/LegalNoticePage'
import { PrivacyPage } from './pages/PrivacyPage'
import { TermsPage } from './pages/TermsPage'
import { CookiesPage } from './pages/CookiesPage'
import { Footer } from './components/layout/Footer'
import { SuggestionsPage } from './pages/SuggestionsPage'

function App() {
  return (
    <AuthProvider>
      <Box sx={{ minHeight: '100vh' }}>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/test-images" element={<ImageTest />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/activate/:token" element={<ActivationPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/legal" element={<LegalNoticePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard/projects" replace />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="profile" element={<UserProfile />} />
            <Route path="suggestions" element={<SuggestionsPage />} />
          </Route>
        </Routes>
        <Footer />
      </Box>
    </AuthProvider>
  )
}

export default App